__turbopack_context__.v({
  "badge": "VhLHFG_badge",
  "checkbox": "VhLHFG_checkbox",
  "content": "VhLHFG_content",
  "disabled": "VhLHFG_disabled",
  "root": "VhLHFG_root",
});
